module.exports = __webpack_public_path__ + "1ab5adaf4dab3898ce4a7d301548f5ee.jpg";